import React from 'react';
import {Box} from '@mui/material';
import {MENU_BAR_WIDTH} from '../../../components/MenuBarV2';
import {Outlet} from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

export default function Workbook() {
  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        width: `calc(100% - ${MENU_BAR_WIDTH}px)`,
        paddingBottom: '100px',
        paddingRight: '10px',
      }}
    >
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    </Box>
  );
}
